import { LoadingSpinner } from "@newsela/angelou";

import { VIEW_PAGE_LUNA_AI_DESIGN } from "@/ai/constants/experiments";
import AILoadingSpinner from "@/components/AIComponents/AILoadingSpinner";
import useHasFeature from "@/features/useHasFeature";
import {
  bodyStyles,
  loadingLabelStyles,
  loadingSpinnerStyles,
} from "./TranslateDrawer.style";

const TranslateDrawerLoading = () => {
  const [showLunaAiBranding] = useHasFeature(VIEW_PAGE_LUNA_AI_DESIGN);

  return (
    <div css={bodyStyles}>
      {showLunaAiBranding ? (
        <AILoadingSpinner __cssFor={{ root: loadingSpinnerStyles }} />
      ) : (
        <LoadingSpinner __cssFor={{ root: loadingSpinnerStyles }} />
      )}
      <p css={loadingLabelStyles}>Translating...</p>
    </div>
  );
};

export default TranslateDrawerLoading;
